import { render, staticRenderFns } from "./orderShouHou.vue?vue&type=template&id=73333862"
import script from "./orderShouHou.vue?vue&type=script&lang=js"
export * from "./orderShouHou.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports